import { render, staticRenderFns } from "./PageUserCommissionChangeLog.vue?vue&type=template&id=219522fe&scoped=true"
import script from "./PageUserCommissionChangeLog.vue?vue&type=script&lang=js"
export * from "./PageUserCommissionChangeLog.vue?vue&type=script&lang=js"
import style0 from "./PageUserCommissionChangeLog.vue?vue&type=style&index=0&id=219522fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219522fe",
  null
  
)

export default component.exports